import { EffectCallback, useEffect } from 'react';

const useMount = (fn: EffectCallback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(fn, []);
};

export default useMount;
